import React, { useEffect, useState } from "react";
import { API_cursos } from "../../config/apiConfig";
import { Link } from "react-router-dom";
import { FaUser } from "react-icons/fa6";
import "../../pages/user/css/Empleo.css";
import { useAuth } from "../../context/AuthContext";
import { compareDesc } from "date-fns";

const FormacionDestacada = ({ categoria }) => {
  const { token } = useAuth();
  const [cursos, setCursos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const obtenerCursos = async () => {
      try {
        const response = await fetch(`${API_cursos}`, {
          headers: {
            "x-auth-token": token,
          },
        });
        const data = await response.json();

        const hoy = new Date();
        let filtradas = data;

        if (categoria === "destacadas") {
          filtradas = data.filter((curso) => {
            const fechaLimite = new Date(curso.finalRegistration);
            return curso.isFeatured && compareDesc(hoy, fechaLimite) >= 0;
          });
        } else if (categoria === "online") {
          filtradas = data.filter((curso) => curso.modality?.toLowerCase() === "online");
        } else if (categoria === "presencial") {
          filtradas = data.filter((curso) => curso.modality?.toLowerCase() === "presencial");
        } else if (categoria === "semipresencial") {
          filtradas = data.filter((curso) => curso.modality?.toLowerCase() === "mixto");
        } // "todos" muestra todo sin filtro

        setCursos(filtradas);
      } catch (error) {
        console.error("Error al obtener cursos:", error);
        setCursos([]);
      } finally {
        setLoading(false);
      }
    };

    obtenerCursos();
  }, [categoria]);

  if (loading) return <p>Cargando cursos...</p>;
  if (cursos.length === 0) return <p className="mt-30">Lo sentimos, pero en este momento no tenemos cursos con estas características.</p>;

  // Fecha en formato DD/MM/AAAA
  const formatearFecha = (fecha) => {
    const date = new Date(fecha);
    return date.toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  return (
    <div className="carrusel wrap w-100">
      {cursos.map((curso, index) => (
        <>
          <div key={index} className="recurso formacion">
            <h2 className="mayusculas">{curso.title}</h2>
            <p>{curso.institutionalFacility}</p>
            <p className="fecha">
              {formatearFecha(curso.startDate)} - {formatearFecha(curso.endDate)}
            </p>
            <p className="align-center gap-5 ubicacion">
              <FaUser />
              {curso.targetUsers}
            </p>
            <Link className="rosa" to={`/formacion/${curso._id}`} aria-label="Más información sobre el curso">
              Más información
            </Link>
          </div>
        </>
      ))}
    </div>
  );
};

export default FormacionDestacada;
